export default __webpack_public_path__ + "static/media/004-B-presse.1e628d1c.svg";